import { format, isValid, parse, parseISO } from "date-fns";
import React from "react";
import InputMask from "@mona-health/react-input-mask";
import { DatePickerWrapper } from "../date/DatePickerWrapper";
import { YearPicker } from "../date/YearPicker";

export function createDefaultInput(
	id,
	label,
	onInputChange,
	onCriterionInputChange,
	placeholder,
	value,
) {
	return (
		<input
			type="number"
			id={id}
			value={value}
			aria-label={label}
			placeholder={placeholder}
			onChange={(e) => onInputChange(e.target.value)}
			data-criterion={true}
		/>
	);
}

export function createMaskedInput(
	id,
	label,
	onInputChange,
	onCriterionInputChange,
	placeholder,
	value,
) {
	return (
		<InputMask
			type="text"
			id={id}
			value={value}
			placeholder={placeholder}
			aria-label={label}
			mask="99:99"
			maskPlaceholder="0"
			alwaysShowMask
			onChange={(e) => onInputChange(e.target.value)}
			data-criterion
		/>
	);
}

export function createDatePicker(
	id,
	label,
	onInputChange,
	onCriterionInputChange,
	placeholder,
	value,
	filterDate,
	years,
	criterionKey,
) {
	return (
		<DatePickerWrapper
			id={id}
			filterDate={filterDate}
			onInputChange={onInputChange}
			onCriterionInputChange={onCriterionInputChange}
			value={value}
			years={years}
			criterionKey={criterionKey}
		/>
	);
}

export function createYearPicker(
	id,
	label,
	onInputChange,
	onCriterionInputChange,
	placeholder,
	value,
	filterDate,
	years,
	criterionKey,
) {
	return (
		<YearPicker
			id={id}
			filterDate={filterDate}
			onChange={onInputChange}
			placeholder={placeholder}
			label={label}
			value={value}
			years={years}
			criterionKey={criterionKey}
		/>
	);
}

export function formatInput(date) {
	if (!date) {
		return "";
	}

	return format(date, "ddMMMyyyy").toUpperCase();
}

export function inputToDate(input) {
	return parse(input, "ddMMMyyyy", new Date());
}

export function isInputValidDate(input) {
	return isValid(inputToDate(input));
}

export const getInputRange = (inputMin, inputMax, dateRange) => {
	let min = inputMin;
	let max = inputMax;

	if (min || max) {
		if (dateRange) {
			min = min ? formatInput(parseISO(min)) : min;
			max = max ? formatInput(parseISO(max)) : max;
		}

		return (min || "...") + " - " + (max || "...");
	}

	return null;
};

export const filterDate = (date, min = 2000, max = 2100) => {
	if (!date) {
		return true;
	}

	const year = date.getFullYear();

	return year >= min && year <= max;
};
